import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import ProjectJobMatching from '../types/jobMatch/ProjectJobMatching';
import ProjectAvailableJobMatching from '../types/jobMatch/ProjectAvailableJobMatching';

const AdminJobMatchService = {
    getJobMatchings,
    getAvailableJobMatchings,
    assignProject,
};

const BASE_URL = '/admin/products';

interface BasePayload {
    productId: number;
    projectId: number;
}

const createUrl = (productId: number, projectId: number) => {
    return `${BASE_URL}/${productId}/projects/${projectId}/job-matchings`;
};

async function getJobMatchings(
    payload: BasePayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { productId, projectId } = payload;
    try {
        return await RequestService.get<ProjectJobMatching[]>(
            createUrl(productId, projectId),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist job matche'),
        ); // TODO: translate

        throw e;
    }
}

type AssignPayload = {
    jobMatchings: { jobMatchingId: number }[];
};

async function assignProject(
    payload: BasePayload & AssignPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { productId, projectId, jobMatchings } = payload;
    try {
        return await RequestService.post<{ jobMatchingId: number }[]>(
            createUrl(productId, projectId),
            jobMatchings,
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se priradit projekt'),
        ); // TODO: translate

        throw e;
    }
}

async function getAvailableJobMatchings(
    payload: BasePayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { productId, projectId } = payload;
    try {
        return await RequestService.get<ProjectAvailableJobMatching[]>(
            createUrl(productId, projectId) + '/available',
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist job matche'),
        ); // TODO: translate

        throw e;
    }
}

export default AdminJobMatchService;
